export default __webpack_public_path__ + "static/media/minimize.230168aa.svg";